import { get_user_metrics } from '../actions/types';

const INITIAL_STATE = {
  userMetrics: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case get_user_metrics:
      return { ...state, userMetrics: action.payload };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/MetricsReducer.js